export default {
  pt: {
    'components.dataTable.loadErrorTitle': 'Não foi possível carregar',
    'components.dataTable.loadErrorMessage': 'Erro ao buscar os dados.',
    'components.dataTable.empty': 'Nenhum registro encontrado.',
    'components.dataTable.records_one': '{{count}} registro',
    'components.dataTable.records_other': '{{count}} registros',
  },
  en: {
    'components.dataTable.loadErrorTitle': 'Could not load',
    'components.dataTable.loadErrorMessage': 'An error occurred while fetching the data.',
    'components.dataTable.empty': 'No records found.',
    'components.dataTable.records_one': '{{count}} record',
    'components.dataTable.records_other': '{{count}} records',
  },
  es: {
    'components.dataTable.loadErrorTitle': 'No se pudo cargar',
    'components.dataTable.loadErrorMessage': 'Se produjo un error al obtener los datos.',
    'components.dataTable.empty': 'No se encontraron registros.',
    'components.dataTable.records_one': '{{count}} registro',
    'components.dataTable.records_other': '{{count}} registros',
  },
}
